import script from "./PrivacyPolicyDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPolicyDialog.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyPolicyDialog.vue?vue&type=style&index=0&id=3fdb0ca9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fdb0ca9"]])

export default __exports__